( function( $ ) {

    $(document).ready( function() {
        // Page removes all this from the dom the reinserts it. Need to bind events to document instead of element
        
        
        // Accordion Block
        $(window).bind('load resize', function() {
            $('.accordion-body-wrapper').each(function() {
                let height = $(this).children('.accordion-body-inner').outerHeight() + 'px';
                $(this).css('--body-height', height);

            });
        });


        $(document).on('click', '.accordion-title', function() {
            console.log('Toggle accordion');
            const $accordionItem = $(this).parent();
            
            if($accordionItem.hasClass('open')) {
                $accordionItem.removeClass('open');
            } else {
                $('.accordion-item').removeClass('open');
                $accordionItem.addClass('open');
                
                // Calculate position and scroll AFTER animation completes (450ms + buffer)
                setTimeout(function() {
                    const rect = $accordionItem[0].getBoundingClientRect();
                    const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;
                    
                    if (!isInView) {
                        const elementPosition = rect.top + window.pageYOffset;
                        window.scrollTo({
                            top: elementPosition - 300,
                            behavior: 'smooth'
                        });
                    }
                }, 700);
            }
        });

    } );

} )( jQuery );
